import {
  Button,
  ButtonGroup,
  Container,
  Divider,
  SkeletonText,
  Table,
  TableContainer,
  Tabs,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import iconArrowLeftRight from "assets/icons/icon-arrow-left-right.svg";
import IconCheckDouble from "assets/icons/icon-check-double.svg?react";
import ButtonRemoveResource from "components/ButtonRemoveResource";
import EmailRowTitle from "components/ui/EmailRowTitle";
import EmptyList from "components/ui/EmptyList";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useReviewNewsletters } from "../hooks/useReviewNewsletters";

export default function PageNewslettersForReview() {
  const { isFetched, data: newsletters } = useReviewNewsletters();

  const hasData = newsletters && newsletters.length > 0;

  return (
    <Tabs index={1} variant="line">
      <Header />

      <Divider />

      <Container flexDirection="column">
        <SkeletonText isLoaded={isFetched}>
          {hasData ? (
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Assunto</Th>
                    <Th>Cliente</Th>
                    <Th>Lista</Th>
                    <Th>Destinatários</Th>
                    <Th w="120px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {newsletters.map((newsletter) => (
                    <Tr key={newsletter.id}>
                      <Td>
                        <EmailRowTitle title={newsletter.subject} />
                      </Td>
                      <Td>{newsletter.list.company.name}</Td>
                      <Td>{newsletter.list.name}</Td>
                      <Td>{newsletter.email.countRecipients}</Td>

                      <Td textAlign="right">
                        <ButtonGroup>
                          <Button
                            size="sm"
                            rightIcon={<IconCheckDouble />}
                            as={Link}
                            to={`/disparos-de-newsletter/${newsletter.id}/revisar`}
                          >
                            Revisar
                          </Button>
                          <ButtonRemoveResource
                            id={newsletter.id}
                            pathName="newsletterS"
                            queryKey={['newsletters-review', 'newsletters-review-count']}
                          />
                        </ButtonGroup>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <EmptyList
              mt="30px"
              icon={iconArrowLeftRight}
              title="Nenhuma newsletter aguardando revisão"
              description="Todas as newsletters foram revisadas ou não há newsletters que requerem revisão no momento"
              isTable
            />
          )}
        </SkeletonText>
      </Container>
    </Tabs>
  );
}
